import { getAccessToken } from '@/helper/auth-helper'

export default function auth({ next }) {
  if (!getAccessToken()) {
    return next({ name: 'Login' })
  }

  return next()
}
